import { useAuth } from '@frontegg/react';
import { useContext } from 'react';
import { TenantContext } from '../../contexts/tenantContext';

const useFetcher = () => {
    const { user } = useAuth();
    const context = useContext(TenantContext);

    if (!context) {
        throw new Error('Surveys must be used within a TenantContext.Provider');
    }

    const selectedSchema = context;

    return (url: string) => fetch(url, {
        headers: {
            Authorization: `Bearer ${user.accessToken}`,
            'X-Selected-Schema': selectedSchema[0] || '',
        },
    }).then(async (res) => {
        if (res.status !== 200) {
            const body = await res.json().catch(() => null);
            const detail = body?.detail;
            const message = typeof detail === 'string'
                ? detail
                : 'An error occurred while fetching the data.';
            throw new Error(message);
        }

        return res.json();
    });
};

export default useFetcher;
